import '@theme/product-form';
if (!customElements.get('topbrush-cart-choice')) {
 customElements.define('topbrush-cart-choice', class extends HTMLElement {
  connectedCallback() {
   this.addEventListener('change',this.choose); this.addEventListener('submit',this.submit);
   const dialog=this.closest('dialog');
   const load=()=>{
    if(dialog&&!dialog.open)return;
    this.querySelectorAll('img[data-cart-offer-src]').forEach(img=>{img.src=img.dataset.cartOfferSrc;delete img.dataset.cartOfferSrc;});
   };
   this.observer=new MutationObserver(load);
   this.observer.observe(this,{childList:true,subtree:true,attributes:true,attributeFilter:['data-cart-offer-src']});
   if(dialog)this.observer.observe(dialog,{attributes:true,attributeFilter:['open']});
   load();
  }
  disconnectedCallback() { this.observer?.disconnect(); this.removeEventListener('change',this.choose); this.removeEventListener('submit',this.submit); }
  choose=(event)=>{
   if (!event.target.matches('[data-cart-choice]')) return;
   this.querySelector('input[ref="variantId"]').value=event.target.value;
  };
  submit=(event)=>{
   const native=this.querySelector('product-form-component');
   if (typeof native?.handleSubmit==='function') native.handleSubmit(event);
  };
 });
}

